<template>
  <div class="card">
    <card-m title="设计任务分配情况" cardWidth="100%" cardHeight="90%">
      <template slot="card-box">
        <cardTable
          :total="totalCounts"
          :tableColumn="column"
          :tableData="tableData"
          :loading="loading"
          :showPaging='false'
        >
        </cardTable>
      </template>
    </card-m>
  </div>
</template>

<script>
//import cardTable from './card-table.vue';
import { apiMain, apiMainMultiple } from '@/api/mainapi.js';
export default {
  //components: { cardTable },
  name: 'card-M',
  props: {
    contractId:String
  },
  data() {
    return {
      totalCounts:0,
      column:[
        {
          
          prop: 'field0122',
          label: '父项型号'
        
        },
        {
          
          prop: 'field0107',
          label: '设计人'
        
        },
        {
          
          prop: 'field0102',
          label: '数量'
        
        },
        {
          
          prop: 'field0113',
          label: '难度'
        
        }
      ],
      tableData:[],
      loading:false,
    };
  },
  mounted(){
    this.getTableData()
  },
  methods: {
    // 获取接口
  async  getTableData(id){
    const params = {
      Type:"TaskAssignment",
      contractNo:id,
    }
    const res = await apiMain(params)
    this.tableData = res.data.data
    }
  }
};
</script>

<style scoped scoped lang="scss">
.card{
  width: 100%;
  height: 100%;
}
</style>
